( function( $ ) {
    "use strict";

    var DataHref = {
        onClick: function(ev) {
            var $this = $(this);

            window.location.assign($(this).data('href'));
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $dataHrefElements = $container.find('[data-href]');

        $dataHrefElements
            .on('click.datahref', DataHref.onClick);
    });

}( jQuery ));
